export const PrivacyPolicy = () => {
  return (
    <div className="py-xl text-center text-m font-reg text-black">
      Find out how we use your data in our&nbsp;
      <a
        href="/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-denim-25"
      >
        Privacy Policy
      </a>
    </div>
  );
};
